module.exports = __webpack_public_path__ + "static/media/searchIcon.f667dccf.svg";